import { Suspense } from "react";
import { View } from "tamagui";

import { LoadingScreen } from "~/components/blocks";
import { GroupsFilterProvider } from "~/components/blocks/filters/groups-filter";
import {
  GroupsGrid,
  GroupsHeader,
} from "~/components/feature/groups-management";
import { MainPageWrapper } from "~/components/layout/layout";

const Groups = () => {
  return (
    <MainPageWrapper>
      <GroupsFilterProvider>
        <View gap={"$5"}>
          <GroupsHeader />
          <Suspense
            fallback={<LoadingScreen height={"100dvh"} width={"100%"} />}
          >
            <GroupsGrid />
          </Suspense>
        </View>
      </GroupsFilterProvider>
    </MainPageWrapper>
  );
};

export default Groups;
